import { render, staticRenderFns } from "./UiFakeScrollBox.vue?vue&type=template&id=5515421e"
import script from "./UiFakeScrollBox.vue?vue&type=script&lang=js"
export * from "./UiFakeScrollBox.vue?vue&type=script&lang=js"
import style0 from "./UiFakeScrollBox.vue?vue&type=style&index=0&id=5515421e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports